import React from 'react';
import PropTypes from 'prop-types';

/**
 * Tray close component.
 *
 * @param {React.ComponentProps} props - component props
 * @returns {React.ReactElement} close button.
 * @api public
 */
function TrayClose(props) {
  return (
    <button
      className='close'
      onClick={ props.onClick }
      aria-label='close' />
  );
}


/**
 * Property definitions.
 *
 * @type {Object}
 * @public
 */
TrayClose.propTypes = {
  onClick: PropTypes.func.isRequired
};

export default TrayClose;
